module.exports = __webpack_public_path__ + "img/Img.0f17f508.svg";